import { OpsFeedsSearchModel } from '../search/feeds_search_types';
import { getFeedTypeOptions, getStatusOptions, getSourceOptions } from '../../data/feedsRepo';
import {
    ALL_SELECTED_LABEL_1,
    ALL_SELECTED_LABEL_2,
    ALL_SELECTED_LABEL_3,
} from '../../../../core/components/validation/ValidInputMultiSelect';

const keysWithOptions = ['CE', 'RX', 'FeedType', 'Status', 'Source'] as const;

export function cleanFeedsSearchPayload(state: OpsFeedsSearchModel, uiMode: string): OpsFeedsSearchModel {
    const cleanedState: OpsFeedsSearchModel = { ...state };
    const allOptions = {
        CE: state.CE.options?.map(opt => opt.val) || [],
        RX: state.RX.options?.map(opt => opt.val) || [],
        FeedType: getFeedTypeOptions(uiMode),
        Status: getStatusOptions(),
        Source: getSourceOptions(),
    };

    keysWithOptions.forEach(key => {
        const selected = cleanedState[key]?.val || [];
        if (
            selected.length === 1 &&
            (selected[0] === ALL_SELECTED_LABEL_1 ||
                selected[0] === ALL_SELECTED_LABEL_2 ||
                selected[0] === ALL_SELECTED_LABEL_3)
        ) {
            cleanedState[key] = { ...cleanedState[key], val: [] };
        } else if (isAllSelected(selected, allOptions[key])) {
            cleanedState[key] = { ...cleanedState[key], val: [] };
        }
    });

    cleanedState.RX = {
        ...state.RX,
        val: state.RX?.options?.length === state.RX.val.length ? [] : state.RX?.val,
    };

    return cleanedState;
}

export function isAllSelected(selected: string[], options: string[] | (string | number)[]): boolean {
    const filtered = selected.filter(
        v => v !== ALL_SELECTED_LABEL_1 && v !== ALL_SELECTED_LABEL_2 && v !== ALL_SELECTED_LABEL_3,
    );
    return options.length > 0 && filtered.length === options.length;
}
